// extracted by mini-css-extract-plugin
export var chevron = "_1r-d";
export var disabled = "_1r-b";
export var error = "_1r-c";
export var hideBorder = "_1r-1";
export var icon = "_1r-e";
export var input = "_1r-0";
export var large = "_1r-f";
export var open = "_1r-9";
export var placeholder = "_1r-a";
export var regular = "_1r-5";
export var singleRowInput = "_1r-2";
export var singleSelectInput = "_1r-3 _1r-0";
export var small = "_1r-4";
export var spinnerContainer = "_1r-i";
export var tag = "_1r-7";
export var tagsContainer = "_1r-8";
export var tagsInput = "_1r-6 _1r-0";
export var xSmall = "_1r-g";
export var xxSmall = "_1r-h";